export const getInitialExpandedHistoryOpen = (
  isBelowMd: boolean,
): boolean => !isBelowMd;
